module.exports = __webpack_public_path__ + "static/img/l_4.8a3f342.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo/l_4.png
// module id = N7Pr
// module chunks = 1